export default interface Translation {
    [key: string]: string;
}
export function isTranslation(obj: any): obj is Translation {
    if (!obj) return false;
    return obj && typeof obj === "object" && Object.values(obj).every(val => typeof val === "string");
}